module.exports = __webpack_public_path__ + "images/category_lp/car/main-view_3d8cb55b9cab3dcf5ba86415a23318ad.png";